import { dsarRetrievalViews, inputNames } from '../../constants';
export default {
  [dsarRetrievalViews.HOME]: [{
    schema: {
      type: 'Input',
      settings: {
        name: inputNames.REQUEST_ID,
        required: true
      }
    },
    configuration: {
      name: 'Request ID Code Input',
      settings: {
        labelValue: 'Request ID'
      }
    }
  }, {
    schema: {
      type: 'Input',
      settings: {
        name: inputNames.PHONE,
        required: true
      }
    },
    configuration: {
      name: 'Phone Input',
      settings: {
        labelValue: 'Phone'
      }
    }
  }, {
    schema: {
      type: 'Input',
      settings: {
        name: inputNames.SSN,
        required: true
      }
    },
    configuration: {
      name: 'SSN Input',
      settings: {
        labelValue: 'Last 4 of SSN'
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    },
    configuration: {
      text: 'Submit'
    }
  }],
  [dsarRetrievalViews.ONE_TIME_CODE]: [{
    schema: {
      type: 'Input',
      settings: {
        name: inputNames.MFA,
        required: true
      }
    },
    configuration: {
      name: 'Code Input'
    }
  }, {
    schema: {
      type: 'CustomButton',
      settings: {
        onClickName: 'resendCode'
      }
    },
    configuration: {
      name: 'Resend Code Button',
      settings: {
        onClickName: 'resendCode',
        text: 'Resend Code',
        margin: {
          margin: 0
        },
        width: {
          type: 'px',
          value: 100
        },
        padding: {
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 5,
          paddingBottom: 5
        },
        font: {
          fontSize: 12,
          fontWeight: '400',
          color: '#1890ff',
          fontFamily: 'arial, helvetica, sans-serif'
        },
        background: ''
      }
    }
  }, {
    schema: {
      type: 'SubmitButton'
    },
    configuration: {
      text: 'Submit'
    }
  }]
};